
export default class TokenManager{

    //appTokenName = "access_token_eme_2";

    /**
     * Returns localStorage token
     * @param {string} num a number 
     */
    static getToken()
    {
       return localStorage.getItem("access_token_eme_2");
    }

    /**
     * Save app token
     * @param {string} token 
     */
    static setToken(token)
    {   
        localStorage.setItem("access_token_eme_2", token);
    }

    /**
     * Delete app token
     */
    static removeToken()
    {
        localStorage.removeItem("access_token_eme_2");
    }
    
}
